import React from "react";
import Directory from "../../components/directory/directory.component";
import { HomePageContainer } from "./homepage.styles";

export default () => {
  return (
    <HomePageContainer>
      <Directory />
    </HomePageContainer>
  );
};
